/**
 * Portal Configuration
 * 
 * Update this file with your Google Drive folder IDs.
 * Get folder IDs from the folder URL: drive.google.com/drive/folders/[FOLDER_ID]
 */

// Google Drive Folder IDs
// TODO: Replace null with actual folder IDs after creating Google Drive structure
export const FOLDER_IDS = {
  inventory: null,     // "Gloss Operations/Inventory" folder ID
  finance: null,        // "Gloss Operations/Finance" folder ID
  frontdesk: null,     // "Gloss Operations/Front Desk" folder ID
  boh: null,           // "Gloss Operations/Back of House" folder ID
  hr: null,            // "Gloss Operations/HR & Onboarding" folder ID
  marketing: null,     // "Gloss Operations/Marketing" folder ID
  technicians: null    // "Gloss Operations/Technicians" folder ID
};

// Access Configuration
export const ACCESS_CONFIG = {
  // Email domain restriction
  allowedDomain: '@glossnail.bar',
  
  // Roles
  roles: {
    owner: 'Owner',
    coOwner: 'Co-owner',
    gm: 'GM',
    inventory: 'Inventory Manager',
    frontdesk: 'Front Desk Lead',
    marketing: 'Marketing'
  }
};

// External URLs
export const EXTERNAL_URLS = {
  technicians: 'https://glossnail.bar/tech' // Link to technician portal
};

// Display Configuration
export const DISPLAY_CONFIG = {
  // Brand colors (Arch & Bloom palette)
  colors: {
    primary: '#111111',     // Gloss Black
    accent: '#C9A962',      // Gold
    dustyRose: '#BB94A8',   // Dusty Rose
    background: '#f8f9fa'  // Light background
  },
  
  // Typography
  fonts: {
    heading: 'Playfair Display, Georgia, serif',
    body: 'Inter Tight, -apple-system, BlinkMacSystemFont, sans-serif'
  }
};